import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export const useDependentFieldsRevalidation = (
  formScheme: Array<{ dependencies?: string[] }>
) => {
  const { watch, trigger } = useFormContext();

  const allDependencies = useMemo(
    () =>
      formScheme
        .map((field) => field.dependencies)
        .filter(Boolean)
        .flat(),
    [formScheme]
  );

  const uniqueDependencies = useMemo(
    () => Array.from(new Set(allDependencies)),
    [allDependencies]
  );

  useEffect(() => {
    if (uniqueDependencies.length > 0) {
      const subscription = watch((value, { name }) => {
        if (name && uniqueDependencies.includes(name)) {
          trigger(uniqueDependencies as string[]);
        }
      });
      return () => subscription.unsubscribe();
    }
  }, [watch, trigger, uniqueDependencies]);
};
